import { createSlice } from "@reduxjs/toolkit";
import { QbrUser } from "../../types";

export interface AuthState {
  user: QbrUser | null;
  isAuthenticated: boolean;
  userAccessToken: string;
}

const initialState: AuthState = {
  user: null,
  isAuthenticated: false,
  userAccessToken: "",
};

const AuthSlices = createSlice({
  name: "authSlices",
  initialState,
  reducers: {
    setAuth: (state) => {
      state.isAuthenticated = true;
      state.userAccessToken = localStorage?.accessToken ? localStorage.accessToken: "";
      state.user = localStorage?.user ? JSON.parse(localStorage.user): {};
    },
    setAuthLogout: (state) => {
      state.isAuthenticated = false;
      state.userAccessToken = "";
      state.user = null;
      localStorage.clear();
    },
  },
});

const { reducer, actions } = AuthSlices;

export const { setAuth, setAuthLogout } = actions;

export default reducer;
